$( document ).ready(function() {
    if ($(window).width() < 1024) {
            
            $('.nextStep').addClass('hidden');

            $('.answers li').on('click', function(){
                const boxes = $('.boxes') ;       
                
                if(boxes.hasClass('three')){
                    $(this).toggleClass('chacked');
                    ;
                }else{
                    $(this).addClass('chacked');
                }
    
              
                if(boxes.hasClass('one')){
                    boxes.removeClass('one').addClass('two');
                } else if(boxes.hasClass('two')){
                    boxes.removeClass('two').addClass('three');
                }
            });  
            
            $('.box.three .answers li').on('click',function(){
                $('.nextStep').removeClass('hidden').addClass('show');
                $('.boxes.three .box').addClass('clicked');
                $('.skip').addClass('clicked');
            })
    }
});